export default "__VITE_ASSET__PxPgpLiP__"